import React from 'react';
import { useRecoilValue } from 'recoil';
import { Box } from '@mui/material';
import { CFDHistoryLoadingState, CFDHistoryState } from 'features/cfd/state/cfdAtoms';
import { CFDHistoryAutocomplete } from './CFDHistoryAutocomplete';
import { useCFDSelection } from '../hooks/useCFDSelection';

export const CFDSelector: React.FC = () => {
  const CFDHistory = useRecoilValue(CFDHistoryState);
  const cfdHistoryLoading = useRecoilValue(CFDHistoryLoadingState);
  const { selectedCFDName, handleSelectedCFDChange } = useCFDSelection();

  return (
    <Box component='div' sx={{ paddingTop: 1, paddingBottom: 1 }}>
      <CFDHistoryAutocomplete
        history={CFDHistory}
        selectedName={selectedCFDName}
        loading={cfdHistoryLoading}
        onSelectedNameChange={handleSelectedCFDChange}
      />
    </Box>
  );
};
